<template>
  <el-container class="app-container">
    <AppSidebar />
    <el-container class="main-container" >
      <AppHeader />
      <el-main class="main-content">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item v-for="item in breadcrumb" :key="item.path">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppSidebar from './AppSidebar.vue'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppSidebar
  },
  data() {
    return {
      breadcrumb: []
    }
  },
  mounted() {
    this.breadcrumb = this.$route.matched.filter(item=>item.meta && item.meta.title)
    // console.log(this.breadcrumb)
  }
}
</script>

<style scoped>
.app-container {
  height: 100vh;
}

.main-container {
  flex-direction: column;
}

.main-content {
  background-color: #eff2f5;
  padding:0 10px;
  overflow-y: auto;
}

.breadcrumb {
  height: 38px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  padding: 12px 18px;
  background:#eff2f5 url('@/assets/images/cd_xtb_dw.png') no-repeat left center;
  background-size: 12px 14px;
  background-position: 0 center;
}
</style>